module.exports = __webpack_public_path__ + "static/media/close.bfc0521d.mp3";